
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lesson-planning",
      function () {
        return require("private-next-pages/lesson-planning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lesson-planning"])
      });
    }
  